
import { supabase } from "@/integrations/supabase/client";
import { Business, BusinessCategory, BusinessListingFilters } from "@/types";

export const fetchBusinesses = async () => {
  try {
    console.log("Fetching businesses...");
    
    let query = supabase
      .from('businesses')
      .select('*')
      .order('created_at', { ascending: false });
    
    const { data, error } = await query;
    
    if (error) {
      console.error("Error fetching businesses:", error);
      throw error;
    }
    
    if (!data || data.length === 0) {
      console.log("No businesses found");
      return [];
    }
    
    console.log(`Fetched ${data.length} businesses successfully`);
    return data as Business[];
  } catch (error) {
    console.error("Error fetching businesses:", error);
    throw error;
  }
};

export const fetchBusinessById = async (id: string) => {
  try {
    console.log(`Fetching business with ID: ${id}`);
    
    const { data, error } = await supabase
      .from('businesses')
      .select('*')
      .eq('id', id)
      .maybeSingle();
    
    if (error) {
      console.error(`Error fetching business with ID ${id}:`, error);
      throw error;
    }
    
    if (!data) {
      console.log(`No business found with ID ${id}`);
      return null;
    }
    
    console.log(`Successfully fetched business: ${data.name}`);
    return data as Business;
  } catch (error) {
    console.error(`Error fetching business with ID ${id}:`, error);
    throw error;
  }
};

export const fetchBusinessesByCategory = async (category: BusinessCategory) => {
  try {
    console.log(`Fetching businesses in category: ${category}`);
    
    const { data, error } = await supabase
      .from('businesses')
      .select('*')
      .eq('category', category)
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error(`Error fetching businesses in category ${category}:`, error);
      throw error;
    }
    
    if (!data || data.length === 0) {
      console.log(`No businesses found in category ${category}`);
      return [];
    }
    
    console.log(`Fetched ${data.length} businesses in category ${category}`);
    return data as Business[];
  } catch (error) {
    console.error(`Error fetching businesses in category ${category}:`, error);
    throw error;
  }
};

export const searchBusinesses = async (filters: BusinessListingFilters) => {
  try {
    console.log("Searching businesses with filters:", filters);
    
    let query = supabase
      .from('businesses')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (filters.searchTerm) {
      query = query.or(`name.ilike.%${filters.searchTerm}%,description.ilike.%${filters.searchTerm}%`);
    }
    
    if (filters.category) {
      query = query.eq('category', filters.category);
    }
    
    if (filters.city) {
      query = query.eq('city', filters.city);
    }
    
    if (filters.tags && filters.tags.length > 0) {
      // This assumes tags is stored as an array in Supabase
      filters.tags.forEach(tag => {
        query = query.contains('tags', [tag]);
      });
    }
    
    const { data, error } = await query;
    
    if (error) {
      console.error("Error searching businesses:", error);
      throw error;
    }
    
    console.log(`Search returned ${data?.length || 0} results`);
    return data || [];
  } catch (error) {
    console.error("Error searching businesses:", error);
    throw error;
  }
};
